import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-bootstrap';

const EstadoCuentaResumen = ({ totales }) => {
    return (
        <div className="p-3 bg-light border-bottom">
            <Row className="g-2">
                <Col xs={4}>
                    <div className="text-center p-2 bg-white rounded shadow-sm">
                        <div className="text-success fs--2 fw-semi-bold">INGRESOS</div>
                        <div className="text-success fs-0 fw-bold">
                            ${totales?.ingresos?.toLocaleString('es-MX', { minimumFractionDigits: 2 }) || '0.00'}
                        </div>
                    </div>
                </Col>
                <Col xs={4}>
                    <div className="text-center p-2 bg-white rounded shadow-sm">
                        <div className="text-danger fs--2 fw-semi-bold">EGRESOS</div>
                        <div className="text-danger fs-0 fw-bold">
                            ${totales?.egresos?.toLocaleString('es-MX', { minimumFractionDigits: 2 }) || '0.00'}
                        </div>
                    </div>
                </Col>
                <Col xs={4}>
                    <div className="text-center p-2 bg-white rounded shadow-sm">
                        <div className="text-primary fs--2 fw-semi-bold">NETO</div>
                        <div className="text-primary fs-0 fw-bold">
                            ${totales?.neto?.toLocaleString('es-MX', { minimumFractionDigits: 2 }) || '0.00'}
                        </div>
                    </div>
                </Col>
            </Row>
        </div>
    );
};



EstadoCuentaResumen.propTypes = {
    totales: PropTypes.object
};

export default EstadoCuentaResumen;
